import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TemplateCatePage } from './template-cate.page';

const routes: Routes = [
  {
    path: '',
    component: TemplateCatePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TemplateCatePageRoutingModule {}
